/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Cart, CommerceProperty, CommercePropertyValue } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

/** How long a quantity control waits after the last tap before writing the line. */
export const CART_LINE_QUANTITY_DEBOUNCE_MS = 400;

const scalarOf = (value: CommercePropertyValue | undefined): unknown =>
    value?.StringValue ??
    value?.LongValue ??
    value?.IntegerValue ??
    value?.DecimalValue ??
    value?.BooleanValue ??
    value?.DateTimeOffsetValue ??
    value?.ByteValue;

/** Whether the cart already holds every one of the properties, each with the same value. */
export const cartCarriesProperties = (cart: Cart | undefined, properties: CommerceProperty[]): boolean =>
    properties.every(property => {
        const held = cart?.ExtensionProperties?.find(candidate => candidate.Key === property.Key);
        return held !== undefined && scalarOf(held.Value) === scalarOf(property.Value);
    });
